import React, {useCallback, useEffect} from "react";
import {ReactComponent as CloseArrow} from "assets/image/Layout/Common/ic_panel_arrow_right.svg";
import {useGetStudioMode} from "components/Layout/hooks";
import Properties from "components/Properties";
import CustomTooltip from "components/Common/Tooltip/CustomTooltip";
import styles from "./index.module.scss";
import {useIntl} from "react-intl";
import {PROPERTY_TAB} from "utils";
import {useDispatch, useSelector} from "react-redux";
import {changeCurrentPropertyTab} from "store/actions/propertyPanel";

function PropertyPanel({isPropertyPanelOpen, handlePropertyPanel}) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const {currentTab} = useSelector(state => state.propertyPanel);

  let {selectedObjects} = useSelector(state => state.asset);
  useEffect(() => {
    if (selectedObjects.length === 0) dispatch(changeCurrentPropertyTab("Scene"));
    else dispatch(changeCurrentPropertyTab("Object"));
  }, [selectedObjects[0]?.key]);

  const {isEditMode} = useGetStudioMode();

  const handlePropertyTab = useCallback(tab => {
    dispatch(changeCurrentPropertyTab(tab));
  }, []);

  return (
    <section className={`${styles.container} ${!(isPropertyPanelOpen && isEditMode) ? styles.closed : ""}`}>
      <div className={styles.wrapper}>
        <div className={styles.title}>
          <div className={styles.tab_wrapper}>
            <div
              className={`${currentTab === "Object" ? styles.active : styles.inactive}`}
              onClick={() => handlePropertyTab(PROPERTY_TAB.OBJECT)}
            >
              {PROPERTY_TAB.OBJECT}
            </div>
            <div
              className={`${currentTab === "Scene" ? styles.active : styles.inactive}`}
              onClick={() => handlePropertyTab(PROPERTY_TAB.SCENE)}
            >
              {PROPERTY_TAB.SCENE}
            </div>
          </div>
          <CustomTooltip description={intl.formatMessage({id: "ID_STUDIO_TOOLTIP_PROPERTY_PANEL_CLOSE"})} placement={"bottomRight"}>
            <button type="button" className={styles.close_btn} onClick={handlePropertyPanel}>
              <CloseArrow />
            </button>
          </CustomTooltip>
        </div>
        {isPropertyPanelOpen && <Properties currentTab={currentTab} />}
      </div>
    </section>
  );
}

export default React.memo(PropertyPanel);
